import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    cardOneTitle: {
        id: '_.rbl_dashboard.approved_benefits.card_one_title',
        defaultMessage: 'Repay when you get paid'
    },
    cardOneContent: {
        id: '_.rbl_dashboard.approved_benefits.card_one_content',
        defaultMessage:
            'If your sales slow down, so do your repayments - you will just need to cover a set amount every {interval} months.'
    },
    cardTwoTitle: {
        id: '_.rbl_dashboard.approved_benefits.card_two_title',
        defaultMessage: 'No need for spreadsheets'
    },
    cardTwoContent: {
        id: '_.rbl_dashboard.approved_benefits.card_two_content',
        defaultMessage:
            'Open Banking lets us automatically keep track of your revenue, so you always repay the right amount. No need for any number-crunching on your end.'
    },
    cardThreeTitle: {
        id: '_.rbl_dashboard.approved_benefits.card_three_title',
        defaultMessage: 'Have help on hand'
    },
    cardThreeContent: {
        id: '_.rbl_dashboard.approved_benefits.card_three_content',
        defaultMessage:
            "You'll have your own Account Manager to help you get the most from your Cash Advance, and get to grips with how it all works."
    },
    borrowUpTo: {
        id: '_.rbl_dashboard.approved_borrow_copy',
        defaultMessage: 'You can borrow up to'
    },
    withRBL: {
        id: '_.rbl_dashboard.approved_with_rbl',
        defaultMessage: 'with a Revenue Based Loan.'
    },
    revenueStream: {
        id: '_.rbl_dashboard.approved_revenue_stream',
        defaultMessage:
            'We calculate your monthly repayments against these eligible sales: eBay, Amazon'
    },
    revenueStreamTooltip: {
        id: '_.rbl_dashboard.approved_revenue_stream_tooltip',
        defaultMessage:
            "This is where we'll be monitoring and taking repayments from. Give us a call if you want it changed."
    }
});
